import { Component, output, input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { PlatformConfigService } from '@core/services/platform-config.service';

@Component({
  selector: 'app-logout-modal',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './logout-modal.component.html',
  styleUrl: './logout-modal.component.css',
})
export class LogoutModalComponent {
  private platformConfigService = inject(PlatformConfigService);

  visible = input<boolean>(false);
  confirm = output<void>();
  cancel = output<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
  currentConfig = this.platformConfigService.currentConfig;
}
